<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>A. M. Sequeira is currently a medical student studying in Tbilisi. She is from India and enjoys spending the final three hours of her night living in another world through writing. She dislikes the idea of a monotonous life; the very idea that many people hate to visualize. She wishes to wake up every day to adrenalin rush but realizes that life is expensive, demanding countless degrees and experiences. It is through her debut book as a first-time author that she explores the aspects of different lives in a single life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?67caae80